import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsResetNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M13.75 8A5.75 5.75 0 003.256 4.75H5V6H1.625A.625.625 0 011 5.375V2h1.25v2.007A7 7 0 111 8h1.25a5.75 5.75 0 0011.5 0z"
        fill=""
      />
    </svg>
  )
);
SvgActionsResetNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsResetNormalXsmall;
